export const news = [
  {
    id: "3001",
    title: "科幻大片《星河之下》定档，东方星空叙事引发期待",
    date: "2026-03-02",
    channel: "影视资讯",
    summary: "历时四年打磨的科幻电影《星河之下》正式定档3月18日，片方发布首支预告，凭借独特的东方星空世界观引发广泛讨论。",
    content: [
      "备受期待的科幻电影《星河之下》日前宣布正式定档，将于3月18日与观众见面。片方同步发布了长达两分钟的首支预告片，短短一天内播放量便突破千万。",
      "影片讲述一艘失联百年的殖民舰重返太阳系的故事，以冷峻的科幻外壳包裹关于孤独与归乡的追问。导演在采访中表示，希望跳出传统的星际战争框架，探讨「家」这一东方语境下的永恒命题。",
      "从曝光的画面来看，影片的美术风格兼具工业冷感与东方诗意，星系、星轨与失重空间的设计极具想象空间。业内人士认为，这部作品有望为国产科幻电影提供新的叙事可能。",
      "据悉，影片后续还将公布幕后制作特辑，进一步揭秘视效与美术的创作过程。",
    ],
    image: "https://readdy.ai/api/search-image?query=cinematic%20space%20galaxy%20nebula%20panorama%20with%20a%20distant%20spaceship%2C%20deep%20teal%20and%20orange%20color%20grading%2C%20epic%20sci-fi%20atmosphere%2C%20editorial%20photography%2C%20high%20detail%2C%20wide%20composition&width=1000&height=600&seq=news-cover-3001&orientation=landscape",
    tags: ["科幻", "定档", "预告"],
  },
  {
    id: "3002",
    title: "悬疑剧《都市迷雾》口碑走高，社会派叙事获观众认可",
    date: "2026-02-26",
    channel: "影视资讯",
    summary: "《都市迷雾》开播两周口碑持续攀升，写实的镜头语言与扎实的剧本被观众称为「近年难得的诚意之作」。",
    content: [
      "悬疑剧《都市迷雾》自开播以来口碑持续走高，多个平台评分稳居高分区，讨论热度居高不下。",
      "该剧以七起跨越十年的失踪案为线索，勾勒出一座城市在高速发展中留下的阴影。与传统的强反转悬疑不同，作品更注重人物的动机与时代背景的描摹，被称为典型的社会派叙事。",
      "有评论指出，剧中大量使用实景拍摄与生活化台词，让人物更加立体可信。随着剧情推进，越来越多的细节伏笔被观众挖掘并展开讨论。",
      "片方表示，后续剧情将逐步揭开核心悬念，敬请观众耐心追看。",
    ],
    image: "https://readdy.ai/api/search-image?query=moody%20modern%20city%20skyline%20at%20night%20with%20fog%20and%20neon%20reflections%2C%20teal%20and%20amber%20tones%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20wide%20composition&width=1000&height=600&seq=news-cover-3002&orientation=landscape",
    tags: ["悬疑", "口碑", "社会派"],
  },
  {
    id: "3003",
    title: "动画电影《山海归途》曝角色海报，水墨美学惊艳网友",
    date: "2026-02-20",
    channel: "影视资讯",
    summary: "《山海归途》发布一组角色海报，水墨与实景结合的画面质感收获大量好评，被赞「每一帧都能当壁纸」。",
    content: [
      "动画电影《山海归途》日前发布了一组全新角色海报，少年、少女与剑客三位主角首次同框亮相。",
      "海报采用水墨与实景相结合的表现手法，远山、流云与浮空岛屿构成一幅瑰丽的东方画卷。角色服饰的纹理与光影细节处理精细，展现出极高的美术水准。",
      "许多网友在社交平台留言，称赞画面「每一帧都能当壁纸」，并对影片的世界观设定充满好奇。片方透露，影片构建了一个人妖共存的奇幻世界，故事将围绕一卷失传的山海图展开。",
      "影片预计于6月1日上映，更多物料将陆续公开。",
    ],
    image: "https://readdy.ai/api/search-image?query=oriental%20ink%20painting%20style%20misty%20mountain%20landscape%20with%20floating%20islands%20and%20clouds%2C%20teal%20ink%20tones%20with%20warm%20orange%20accents%2C%20artistic%20atmospheric%20mood%2C%20wide%20composition&width=1000&height=600&seq=news-cover-3003&orientation=landscape",
    tags: ["动画", "美术", "海报"],
  },
  {
    id: "3004",
    title: "实力派演员齐聚年代剧《光影年代》，重现流金岁月",
    date: "2026-02-14",
    channel: "明星资讯",
    summary: "年代剧《光影年代》官宣主演阵容，多位实力派演员加盟，将共同演绎一位小镇放映员的四十年人生。",
    content: [
      "年代剧《光影年代》近日官宣主演阵容，多位观众熟悉的实力派演员确认加盟，引发广泛关注。",
      "该剧以一位小镇电影放映员的一生为主线，串起中国电影四十年的发展变迁。主创团队表示，选择这一题材，是希望用一个小人物的坚守，唤起观众关于时代与热爱的集体记忆。",
      "为还原不同年代的生活质感，剧组在美术与道具上投入大量心力，从老式放映机到露天影院的座椅，均力求真实。",
      "主演在采访中分享，为了贴近角色，特意前往老放映员家中体验生活，学习胶片放映的完整流程。该剧预计年内与观众见面。",
    ],
    image: "https://readdy.ai/api/search-image?query=vintage%201980s%20cinema%20projector%20room%20with%20warm%20light%20and%20retro%20posters%2C%20teal%20shadows%20with%20amber%20highlights%2C%20nostalgic%20editorial%20photography%2C%20wide%20composition&width=1000&height=600&seq=news-cover-3004&orientation=landscape",
    tags: ["年代剧", "阵容", "主创"],
  },
  {
    id: "3005",
    title: "青年演员程蔚挑战深海题材，为新片接受潜水特训",
    date: "2026-02-08",
    channel: "明星资讯",
    summary: "为出演灾难惊悚片《深海回响》，青年演员程蔚进行了为期两个月的专业潜水与体能训练。",
    content: [
      "青年演员程蔚将在灾难惊悚片《深海回响》中饰演科考队队长，为贴近角色，她进行了为期两个月的专业潜水与体能训练。",
      "据剧组透露，影片大量场景在真实水压环境下拍摄，演员需要掌握闭气、水下沟通等专业技能。程蔚在训练中克服了对深水的恐惧，最终完成了所有高危镜头。",
      "程蔚在采访中表示，这次拍摄让她对深海科考工作者产生了深深的敬意，「他们所面对的孤独与压力，远超常人想象」。",
      "影片已定档1月29日，紧张的密闭空间叙事被观众期待为「大银幕上的一次窒息体验」。",
    ],
    image: "https://readdy.ai/api/search-image?query=deep%20sea%20submarine%20interior%20with%20teal%20underwater%20light%20and%20glowing%20instruments%2C%20cinematic%20tense%20atmosphere%2C%20high%20detail%2C%20wide%20composition&width=1000&height=600&seq=news-cover-3005&orientation=landscape",
    tags: ["演员", "训练", "幕后"],
  },
  {
    id: "3006",
    title: "歌手转战荧屏，云知微首挑古装女主角引热议",
    date: "2026-01-30",
    channel: "明星资讯",
    summary: "人气歌手云知微确认出演奇幻电影女主角，跨界挑战演技，相关话题迅速登上热搜。",
    content: [
      "人气歌手云知微确认出演奇幻电影《山海归途》的女主角，这是她首次挑战古装大银幕角色，消息公布后迅速引发讨论。",
      "作为拥有大批歌迷的歌手，云知微此前在音乐领域成绩亮眼。此次跨界出演电影，她坦言压力与期待并存，并为此提前半年进行形体与台词训练。",
      "导演在采访中表示，选择云知微正是看中她身上灵动又坚韧的气质，与角色高度契合，「她不是在演，而是成为了那个人」。",
      "面对外界对「歌手演戏」的讨论，云知微回应称，会用作品证明自己的诚意。",
    ],
    image: "https://readdy.ai/api/search-image?query=oriental%20fantasy%20stage%20with%20soft%20mist%20and%20warm%20spotlight%2C%20teal%20and%20orange%20stage%20lighting%2C%20elegant%20cinematic%20mood%2C%20wide%20composition&width=1000&height=600&seq=news-cover-3006&orientation=landscape",
    tags: ["跨界", "主角", "热搜"],
  },
  {
    id: "3007",
    title: "2026开年影视盘点：现实题材与东方幻想双线并进",
    date: "2026-02-22",
    channel: "栏目综述",
    summary: "回顾开年以来的影视市场，现实题材稳扎稳打，东方幻想题材集中爆发，形成鲜明的双线格局。",
    content: [
      "2026年开年以来，影视市场呈现出鲜明的两条主线：一是聚焦普通人生活的现实题材，二是构建东方世界观的幻想题材。",
      "现实题材方面，多部作品以扎实的剧本与生活化的表演赢得口碑，观众对「讲好一个故事」的诉求愈发强烈。而在幻想题材领域，无论是科幻、奇幻还是仙侠，都涌现出不少在美术与世界观上用心打磨的作品。",
      "业内分析认为，这种双线并进的格局，反映了观众审美日益多元，也说明创作者正在不同的方向上寻找突破。",
      "可以预见，随着更多作品陆续上线，今年的影视市场仍将保持活跃。",
    ],
    image: "https://readdy.ai/api/search-image?query=modern%20film%20industry%20concept%20with%20film%20reels%20and%20cinema%20screens%2C%20teal%20and%20orange%20color%20grading%2C%20editorial%20infographic%20mood%2C%20wide%20composition&width=1000&height=600&seq=news-cover-3007&orientation=landscape",
    tags: ["盘点", "趋势", "市场"],
  },
  {
    id: "3008",
    title: "网络文学改编热持续，多部小说作品进入影视化进程",
    date: "2026-02-16",
    channel: "栏目综述",
    summary: "近期多部热门网络小说宣布影视化立项，改编题材涵盖仙侠、悬疑与都市情感。",
    content: [
      "网络文学与影视的联动持续升温，近期多部热门小说相继宣布进入影视化进程。",
      "从公布的项目来看，改编题材覆盖仙侠、悬疑、都市情感等多个热门赛道，其中不少作品在连载期间便累积了大量读者，拥有天然的受众基础。",
      "有制片人指出，网络小说的优势在于完整的世界观与成熟的人物关系，改编的关键则在于如何将文字的想象转化为影像的表达。",
      "随着改编机制的日益成熟，未来或将有更多优质文本走上荧屏。",
    ],
    image: "https://readdy.ai/api/search-image?query=cozy%20reading%20concept%20with%20stacked%20books%20and%20a%20tablet%20glowing%2C%20teal%20tones%20with%20warm%20orange%20lamp%20light%2C%20editorial%20photography%2C%20wide%20composition&width=1000&height=600&seq=news-cover-3008&orientation=landscape",
    tags: ["网文", "改编", "立项"],
  },
  {
    id: "3009",
    title: "短剧市场百花齐放，精品化趋势渐显",
    date: "2026-02-05",
    channel: "栏目综述",
    summary: "短剧赛道竞争加剧，制作水准与题材多样性显著提升，精品化成为行业共识。",
    content: [
      "近年来快速崛起的短剧市场，正从「量的竞争」转向「质的比拼」。",
      "与早期单一时长的快节奏作品相比，如今的短剧在剧本结构、视听语言与演员表演上均有明显提升，题材也从甜宠拓展到悬疑、职场、家庭等多个方向。",
      "多位从业者认为，观众的审美在提升，粗制滥造的作品很难再获得青睐，精品化是行业发展的必然方向。",
      "与此同时，短剧与长视频、IP衍生之间的联动也在加速，生态日趋完善。",
    ],
    image: "https://readdy.ai/api/search-image?query=smartphone%20showing%20short%20video%20content%20on%20a%20modern%20desk%20with%20soft%20studio%20lighting%2C%20teal%20and%20warm%20orange%20tones%2C%20editorial%20photography%2C%20wide%20composition&width=1000&height=600&seq=news-cover-3009&orientation=landscape",
    tags: ["短剧", "行业", "精品化"],
  },
];